export default __webpack_public_path__ + "static/media/no-team-empty-state.a78dde716f5ddcd895a4d186582acc74.png";